<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-content">
        <div class="footer-section">
          <p class="footer-copyright">&copy; {{ currentYear }} {{ appTitle }}. {{ t('footer.all_rights_reserved') }}</p>
        </div>
        
        <div class="footer-links">
          <a href="#" class="footer-link">{{ t('footer.privacy') }}</a>
          <a href="#" class="footer-link">{{ t('footer.terms') }}</a>
          <a href="#" class="footer-link">{{ t('footer.contact') }}</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const currentYear = new Date().getFullYear();
const appTitle = process.env.VUE_APP_TITLE || 'Misgav';

</script>

<style scoped>
.footer {
  background-color: #ffffff;
  border-top: 1px solid #e5e7eb;
  padding: 1.5rem 2rem;
  margin-top: auto;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.footer-section {
  flex: 1;
}

.footer-copyright {
  margin: 0;
  font-size: 0.875rem;
  color: #6b7280;
  line-height: 1.5;
}

.footer-links {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
}

.footer-link {
  font-size: 0.875rem;
  color: #6b7280;
  text-decoration: none;
  transition: color 0.2s ease;
  line-height: 1.5;
}

.footer-link:hover {
  color: #228fc5;
}

/* RTL Support */
.footer-links {
  direction: var(--direction);
}

/* Mobile Responsive */
@media (max-width: 640px) {
  .footer {
    padding: 1rem 1.5rem;
  }
  
  .footer-content {
    flex-direction: column;
    text-align: center;
    gap: 0.75rem;
  }
  
  .footer-links {
    justify-content: center;
    gap: 1.5rem;
  }
}

/* Dark mode support (optional, matches success page if dark mode is used) */
@media (prefers-color-scheme: dark) {
  .footer {
    background-color: #1f2937;
    border-top-color: #374151;
  }
  
  .footer-copyright {
    color: #9ca3af;
  }
  
  .footer-link {
    color: #9ca3af;
  }
  
  .footer-link:hover {
    color: #22c55e;
  }
}
</style>